import {
  camelCase,
  cloneDeep,
  isArray,
  isPlainObject,
  map,
  mapKeys,
  mapValues,
  snakeCase,
} from 'lodash';
type CasingFunction = (input: string) => string;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ConvertKeysFunction = (object: any) => any;
const objectKeysToCase = (casing: CasingFunction): ConvertKeysFunction => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const convertKeysToCase: ConvertKeysFunction = (object: any): any => {
    if (!isPlainObject(object)) {
      return object;
    }
    let casingObject = cloneDeep(object);
    // Convert keys to case
    casingObject = mapKeys(casingObject, (value, key) => casing(key));
    // Recursively apply throughout object
    return mapValues(casingObject, (value: unknown) => {
      if (isPlainObject(value)) {
        return convertKeysToCase(value);
      }
      if (isArray(value)) {
        return map(value, convertKeysToCase);
      }
      return value;
    });
  };
  return convertKeysToCase;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function toCamelCase(input: unknown): any {
  return objectKeysToCase(camelCase)(input);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function toSnakeCase(input: unknown): any {
  return objectKeysToCase(snakeCase)(input);
}
